import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = ['101 frases que ayudan a educar sin gritar.', 'Actividades para desarrollar la inteligencia emocional.', '50 situaciones reales y cómo resolverlas.', 'Rutinas que transforman el día.'];
  return <section className="py-16 px-4 md:px-8 max-w-4xl mx-auto" data-id="element-12">
      <div className="bg-brand-peach/10 rounded-3xl p-8 md:p-12 border border-brand-peach/20 text-center" data-id="element-13">
        <div className="inline-block bg-brand-peach text-white font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider mb-6" data-id="element-14">
          Regalos Exclusivos
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-brand-textDark mb-8" data-id="element-15">
          Además recibís GRATIS estos 4 bonos exclusivos
        </h2>

        <div className="grid sm:grid-cols-2 gap-4 text-left mb-8" data-id="element-16">
          {bonuses.map((bonus, index) => <div key={index} className="bg-white p-4 rounded-xl shadow-sm border border-brand-peach/10 flex items-start space-x-3" data-id="element-17">
              <Gift className="w-6 h-6 text-brand-peachDark shrink-0" data-id="element-18" />
              <span className="text-brand-textDark font-medium" data-id="element-19">{bonus}</span>
            </div>)}
        </div>

        <p className="text-lg font-semibold text-brand-sageDark" data-id="element-20">
          Todo listo para aplicar desde el primer día.
        </p>
      </div>
    </section>;
}